<div
  class="order-list p-datalist"
  cdkDropListGroup
  fgInfiniteScroll
  (scrolled)="onScroll.emit()"
  [scrollFinished]="scrollFinished"
  [containerScroll]="containerScroll"
  [style.padding]="padding"
  [style.maxHeight]="maxContainerHeight"
  [class.use-max-tile-width]="useMaxTileWidth"
>
  <ng-template #loadingPlaceholder>
    <loading-list-item *ngIf="loading"></loading-list-item>
  </ng-template>
  <div *ngIf="items?.length; else loadingPlaceholder" class="list-item-container">
    <div
      cdkDropList
      [cdkDropListEnterPredicate]="enter"
      (cdkDropListDropped)="drop()"
      #placeholder
    ></div>
    <div
      *ngFor="let item of items; let i = index"
      cdkDropList
      [cdkDropListEnterPredicate]="enter"
      (cdkDropListDropped)="drop()"
      class="order-list-item"
    >
      <list-item
        cdkDrag
        [data]="item"
        [active]="selectedItem?.id === item.id"
        [itemComponent]="itemComponent"
        (onClick)="onClickItem.emit(item)"
      >
      </list-item>
      <i
        class="pi pi-times remove-icon"
        *ngIf="showDeleteIcon"
        (click)="onDeleteItem.next({ item: item, index: i })"
      ></i>
    </div>
  </div>
  <div class="clearfix"></div>
  <div *ngIf="!loading && !items.length">No Records Found</div>
</div>
